import { Component, HostListener, input, OnDestroy, OnInit, output, signal, } from '@angular/core';
import { EventsService } from '@app/core/services/event.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-user-idle',
    templateUrl: './user-idle.component.html',
    styleUrls: ['./user-idle.component.scss'],
    imports: [],
})
export class UserIdleComponent implements OnInit, OnDestroy {
    restartIdle = input<boolean>(false);
    triggerTimeout = output<boolean>();

    @HostListener('window:keydown')
    @HostListener('window:mousedown')
    @HostListener('window:mousemove')
    checkUserActivity() {
        clearTimeout(this.timeoutId);
        this.checkTimeOut();
    }

    timeoutId: ReturnType<typeof setTimeout>;
    userInactive = signal<boolean>(false);
    inactivityTimeout: number = 30 * 60 * 1000; // 30 minutes
    dialogRef: any;
    isVisible: boolean = false;

    constructor(private eventsService: EventsService) {
        this.checkTimeOut();
    }

    ngOnInit(): void {
        // Keep EventsService pub/sub subscribes — event bus pattern, out of scope
        this.eventsService
            .subscribe('user-idle:confirmed')
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.isVisible = false;
                this.triggerTimeout.emit(true);
                clearTimeout(this.timeoutId);
            });
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeoutId);
    }

    checkTimeOut() {
        this.timeoutId = setTimeout(() => {
            this.userInactive.set(true);
            this.triggerTimeout.emit(false);
            this.showIdleDialog();
        }, this.inactivityTimeout);
    }

    showIdleDialog(): void {
        if (this.isVisible) {
            return;
        }
        this.isVisible = true;
        this.eventsService.publish('user-idle:show');
        /*if (this.dialogRef) return;
        this.dialogRef = this.dialog.open(UserIdlePopupComponent, {
            size: 'sm',
            closeButton: false,
            enableClose: false,
            minHeight: '100px',
        });
        this.dialogRef.afterClosed$.subscribe((result: any) => {
            if (result) {
                this.triggerTimeout.emit(true);
            }
            this.dialogRef = undefined;
        });*/
    }
}
